import { createSelector } from 'reselect'

import selectJiraSitesById from './selectJiraSitesById'

export default createSelector(selectJiraSitesById, Object.values)
